<a (click)="deleteUserFromGroupRole()">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_delete}}</mat-icon>
</a>